import React, { Component, useEffect, useState, useMemo, useCallback } from 'react'
import { connect } from 'react-redux'
import AcControl from './acControl'
import RoomTheme from "./RoomTheme"
import {
    sendCommand, setPowerSwitch, TempChange,
    sendACCommand, setSelectedZone, restoreValue, setSelectedAC, sendAcCommand, setAcSelected,
    VDAsendCommand
} from '../../../../action/roomControlAction'
import { scrollDownEffect } from '../scrollEffect';
import {setDNDon, setGoHome, setLoader, setMURon, setOpenDemoCamera, setOpenExternalLinkInSameTab} from '../../../action/homeAction'
import { guestDetails, sendAnalytics } from '../../../../action/homeAction'
import { currentWidget, openSMSWidget, popupOpenClose, setDeviceConfigFailed, setFailScreen, setMobileTVPage, setMultiSubWidget, setOpenProfileImage, setRegPage } from '../../../../action/action'
import { nonCompWidgetClick } from '../../../JS/widgetHandling'
import { withTranslation } from 'react-i18next'
import { setRoomControlPage } from '../../../action/action'
import { closeOrderPopUp } from '../../../action/hCommerce2'


const mapStateToProps = state => {
    return {
        guestDetail: state.store.home.guestDetails,
        currentWidget: state.store.sideNavBar.currentWidget,
        logo: state.store.home.currentDuration.brandingInfo ?
            state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
        selectedZone: state.store.roomControl.selectedZone,
        celciusMax: state.store.VDARoomControl.celciusMax,
        configs: state.store.VDARoomControl.configs,
        currentFanSpeed: state.store.VDARoomControl.currentFanSpeed,
        celciusMin: state.store.VDARoomControl.celciusMin,
        farenheitMax: state.store.VDARoomControl.farenheitMax,
        farenheitMin: state.store.VDARoomControl.farenheitMin,
        currentAcTemp: state.store.VDARoomControl.currentAcTemp,
        currentRoomTemp: state.store.VDARoomControl.currentRoomTemp,
        ecoMode: state.store.VDARoomControl.selectedAC.ecoMode,
        seletedIndex: state.store.roomControl.seletedIndex,
        currentWidgets: state.store.sideNavBar.currentWidget,
        zoneCount: state.store.roomControl.zoneCount,
        VDAZoneList: state.store.roomControl.VDAZoneList,
        hvac: state.store.VDARoomControl.hvac,
        menuColor: state.store.home.MenuColor,
        selectedAC: state.store.VDARoomControl?
        state.store.VDARoomControl.selectedAC : [] ,
        acSelected: state.store.acSelected,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        currentHomePage: state.store2.currentHomePage,
        guestDetail: state.store.home.guestDetails,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        currentWidgets: state.store.sideNavBar.currentWidget,
        appLauncherWidget: state.store.appLauncher.widget,
        DND: state.store.VDARoomControl.DND?
        state.store.VDARoomControl.DND: null,
        MUR: state.store.VDARoomControl.MUR?
        state.store.VDARoomControl.MUR: null,
        streamingUrlFromConfig: state.store.home.clientConfig.doorCameraFeed ?
            state.store.home.clientConfig.doorCameraFeed.doorCameraFeedUrl : null,
        menuColor: state.store.home.MenuColor,
        currentHomePage: state.store2.currentHomePage,
        survey: state.store.survey,
        externalSignIn: state.store2.externalSignIn,
        zoneId: state.store.VDARoomControl.zoneId,
        roomControlSpecificVersion: state.store.home.clientConfig.webAppWidgetsInfo && state.store.home.clientConfig.webAppWidgetsInfo.appConfigs && state.store.home.clientConfig.webAppWidgetsInfo.appConfigs.roomControlSpecificVersion,

    }
}

const mapDispatchToProps =
{
    VDAsendCommand,
    setPowerSwitch,
    sendCommand,
    TempChange,
    sendACCommand,
    setSelectedZone,
    restoreValue,
    setSelectedAC,
    sendAcCommand,
    setAcSelected,
    setGoHome,
    sendAnalytics,
    setFailScreen,
    currentWidget,
    setMultiSubWidget,
    popupOpenClose,
    openSMSWidget,
    setOpenProfileImage,
    setRoomControlPage,
    setDeviceConfigFailed,
    setOpenDemoCamera,
    setRegPage,
    setDNDon,
    setMURon,
    sendAcCommand,
    closeOrderPopUp,
    setOpenExternalLinkInSameTab,
    setMobileTVPage,
    guestDetails,
    sendAnalytics,
    setGoHome,
    setLoader,
    setFailScreen,
  
}

export const PowerIcon=()=>{
    return <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M8.0002 1.33334V8.00001M12.2669 4.40001C13.1046 5.23808 13.6755 6.30546 13.9074 7.46753C14.1393 8.62961 14.022 9.83434 13.5701 10.9298C13.1182 12.0253 12.3521 12.9624 11.3683 13.623C10.3846 14.2836 9.22722 14.6381 8.04223 14.6418C6.85725 14.6456 5.69769 14.2983 4.70981 13.6439C3.72192 12.9894 2.94994 12.0571 2.49123 10.9645C2.03251 9.87189 1.9076 8.66792 2.13224 7.50442C2.35689 6.34091 2.92103 5.26998 3.75353 4.42668" stroke="white" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>;
}

const Tabs = ({selectedTab, setTab, multiControllerWidgetsConfigs})=>{
    return multiControllerWidgetsConfigs &&
    <div class="tabs">

        { multiControllerWidgetsConfigs.tabs.map(tab=>{
            return <div class={`${selectedTab.tabTitle == tab.tabTitle && "selected"} tab`} onClick={()=>setTab(tab)}> {tab.tabTitle}</div>
        })}
    </div>

}

const SingleClickToggle=(props)=>{
    let widget={
        "displayName": props.type.toUpperCase(),
        "compName": props.type.toUpperCase(),
     }

    return <div >
        {props.type && 
            (props.type=="dnd")? "Do Not Disturb":
            (props.type=="mur")? "Make Up Room":""}
        <button onClick={()=>{nonCompWidgetClick(widget, props)}}>{<PowerIcon/>}</button>
    </div>
}

const SingleClickToggleProped = connect(
    mapStateToProps,
    mapDispatchToProps
)(withTranslation('translations')(SingleClickToggle));

function MultiController (props) {
    const [selectedTab, setSelectedTab]= useState(null);
    const [configs, setConfigs]=useState(null);
    

    const mapControlItemToComponent = {
       'AcControl': <AcControl />,
       'roomTheme': <RoomTheme />,
       "dnd":<div class="single-controller"><SingleClickToggleProped type={"dnd"}  /> </div>,
       "mur":<div class="single-controller"><SingleClickToggleProped type={"mur"}  /> </div>
    }

    const setTab=(tab)=>{
        setSelectedTab(tab)
    }

    useEffect(()=>{
        let configs;
     
            configs= props.configs && props.configs.multiControllerWidgetsConfigs;

            
            setConfigs(configs)
            console.log("MultiController mounted", configs)
        
        console.log("MultiController mounted", configs)
        
        if(configs && configs.tabs) setSelectedTab(configs.tabs[0])
        scrollDownEffect(null,"header",props.menuColor,4);
    },[props.configs.multiControllerWidgetsConfigs])


        return  <>
        <div class="multi-controller-container">
        {
            selectedTab &&
            <>
            <Tabs selectedTab={ selectedTab} setTab={setTab} multiControllerWidgetsConfigs={configs} /> 
    
            {  selectedTab.tabItems.map((tabItems)=>{
                console.log(tabItems, "tabItems")
                return mapControlItemToComponent[tabItems];
            })}
            </>

        
        }
             </div>
        </>
    
}


export default connect(
    mapStateToProps, mapDispatchToProps
)(withTranslation('translations')(MultiController));



